import React from 'react';
import Button from '../../button';
import Tooltip from '../../../misc/tooltip';

const InputChip = props => {
  const { text, onRemove, onClick, toolTipText } = props;

  return (
    <span
      className="input-chip"
      ref={node => (toolTipText ? new Tooltip(node, { text: toolTipText, size: 1 }) : null)}
    >
      <div onClick={onClick} className="chip-text">
        {text}
      </div>
      <Button iconOnly="x" onClick={onRemove} iconSize={8} kind="text" />
    </span>
  );
};

export default InputChip;
